import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/projected-ownership-force/actions';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class PlayersQuantity extends Component {
    onChange(value) {
        this.props.dispatch(Action.set('RangeOfProjectedOwnershipForce', value));
    }

    getMaxValue() {
        const {sportConfig} = this.props;

        if (
          (sportConfig.isSiteDraftkings() || sportConfig.isSiteFanduel())
          && (sportConfig.isSportNba() || sportConfig.isSportNfl())
          && sportConfig.isGameTypeClassic()
        ) {
            return 8;
        }

        if (
          (sportConfig.isSiteDraftkings() || sportConfig.isSiteFanduel())
          && sportConfig.isSportNfl()
          && (sportConfig.isGameTypeSingleGame() || sportConfig.isGameTypeShowDown())
        ) {
            return 6;
        }

        return 3;
    }

    getOptions() {
        const minVal = 1;
        const maxVal = this.getMaxValue();
        const options = {};

        for (let i = minVal; i <= maxVal; i++) {
            options[i] = i;
        }

        return options;
    }

    render() {
        const {projectedOwnershipForce} = this.props;
        const playersQuantity = projectedOwnershipForce.getPlayersQuantity();

        return (
            <SimpleSelect
                className="input-sm"
                key={`playersQuantity-${playersQuantity}`}
                value={playersQuantity}
                options={this.getOptions()}
                onChange={::this.onChange}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {
        projectedOwnershipForce,
        sportConfig,
    } = state;

    return {
        projectedOwnershipForce,
        sportConfig,
    };
}

export default connect(mapStatesToProps)(PlayersQuantity);
